import classNames from 'classnames';
import React, { useRef } from 'react';

import type { LabelPropsBase } from '../../interface-and-type';

interface IIndicatorProps
  extends Pick<
    LabelPropsBase,
    'includeNecessityIndicatorInAccessibilityName' | 'isRequired' | 'necessityIndicator'
  > {}

export const DatePickerLabelIndicator: React.FC<IIndicatorProps> = ({
  includeNecessityIndicatorInAccessibilityName = false,
  isRequired,
  necessityIndicator
}) => {
  switch (necessityIndicator) {
    case 'label':
      return (
        <span aria-hidden={!includeNecessityIndicatorInAccessibilityName ? isRequired : undefined}>
          {isRequired ? '*(required)' : '(optional)'}
        </span>
      );
    case 'icon':
      return (isRequired && <span className="text-normal text-rose-600">*</span>) || null;

    default:
      return null;
  }
};

interface IProps extends LabelPropsBase {
  labelClassName?: string;
  // includeNecessityIndicatorInAccessibilityName?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const DatePickerLabel: React.FC<IProps> = React.forwardRef<HTMLLabelElement, IProps>(
  (props, ref) => {
    let {
      children,
      labelClassName,
      labelPosition,
      labelAlign,
      isRequired,
      necessityIndicator = isRequired != null ? 'icon' : null,
      includeNecessityIndicatorInAccessibilityName,
      htmlFor,
      for: labelFor,
      elementType,
      onClick
    } = props;

    const ElementType = elementType ?? 'label';

    const domRef = useRef(ref);

    const className = React.useMemo(() => {
      return classNames('click-label justify-start', labelClassName);
    }, [labelClassName]);

    return (
      <ElementType
        ref={domRef}
        className={className}
        htmlFor={ElementType === 'label' ? labelFor || htmlFor : undefined}
        onClick={onClick}
      >
        {children}
        <DatePickerLabelIndicator
          includeNecessityIndicatorInAccessibilityName={
            includeNecessityIndicatorInAccessibilityName
          }
          isRequired={isRequired}
          necessityIndicator={necessityIndicator}
        />
      </ElementType>
    );
  }
);

DatePickerLabel.displayName = 'DatePickerLabel';
